<template lang="pug">
  div
    slot
    portal(
      to="afterwrap"
    )
      instructions-slide(
        v-model="isDialogOpen"
        v-slot="{ hasInstructions }"
      )
        v-btn.btn-slide-dialog.z-index-6(
          v-if="hasInstructions"
          color="primary"
          @click="showDialog"
        ) Инструкции к разделу
</template>

<script>
import InstructionsSlide from '@/components/dialogs/SlideDialog/index.vue';

export default {
  name: 'TheInstructions',
  components: {
    InstructionsSlide,
  },
  provide() {
    return {
      openInstructions: this.showDialog,
    };
  },
  props: {},
  data() {
    return {
      isDialogOpen: false,
    };
  },
  computed: {
  },
  watch: {},
  created() {},
  methods: {
    showDialog() {
      this.isDialogOpen = true;
    },
  },
};
</script>
